if (!customElements.get("story-popup")) {
    class StoryPopup extends HTMLElement {
        static SELECTORS = {
            trigger: '[data-td-popup-trigger]',
            modal: '[data-td-popup-modal]',
            closer: '[data-td-popup-closer]',
        };

        static FOCUSABLE = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';

        constructor() {
            super();
            this.videoTriggers = this.querySelectorAll(StoryPopup.SELECTORS.trigger);
            this.popups = this.querySelectorAll(StoryPopup.SELECTORS.modal);
            this.closers = this.querySelectorAll(StoryPopup.SELECTORS.closer);
            this.lastTrigger = null;
            this.openPopup = null;
        }

        connectedCallback() {
            this.listenerController = new AbortController();
            const signal = this.listenerController.signal;

            this.videoTriggers.forEach(trigger => {
                trigger.addEventListener('click', () => this.open(trigger), { signal });
                trigger.addEventListener('keydown', (event) => this.activateOnKey(event, () => this.open(trigger)), { signal });
            });

            this.closers.forEach(closer => {
                closer.addEventListener('click', () => this.closeAll(), { signal });
                closer.addEventListener('keydown', (event) => this.activateOnKey(event, () => this.closeAll()), { signal });
            });

            document.addEventListener('keydown', (event) => {
                if (event.key === 'Escape') this.closeAll();
                if (event.key === 'Tab') this.trapFocus(event);
            }, { signal });
        }

        disconnectedCallback() {
            this.listenerController.abort();
        }

        activateOnKey(event, action) {
            if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
                event.preventDefault();
                action();
            }
        }

        open(trigger) {
            const index = trigger.dataset.triggerIndex;
            if (index == null) return;
            this.lastTrigger = trigger;

            this.popups.forEach(popup => {
                if (popup.dataset.popupIndex === index) {
                    popup.style.display = 'flex';
                    popup.setAttribute('aria-hidden', 'false');
                    this.openPopup = popup;
                    const video = popup.querySelector('video');
                    if (video) {
                        video.play().catch(e => console.error('Error attempting to play video:', e));
                    }
                    const closer = popup.querySelector(StoryPopup.SELECTORS.closer);
                    if (closer) closer.focus();
                }
            });
        }

        closeAll() {
            let wasOpen = false;
            this.popups.forEach(popup => {
                if (popup.style.display !== 'none' && popup.getAttribute('aria-hidden') === 'false') {
                    wasOpen = true;
                }
                const video = popup.querySelector('video');
                if (video) video.pause();
                popup.style.display = 'none';
                popup.setAttribute('aria-hidden', 'true');
            });
            this.openPopup = null;
            if (wasOpen && this.lastTrigger) {
                this.lastTrigger.focus();
            }
        }

        trapFocus(event) {
            if (!this.openPopup) return;
            const focusable = Array.from(
                this.openPopup.querySelectorAll(StoryPopup.FOCUSABLE)
            ).filter((el) => el.offsetParent !== null);
            if (focusable.length === 0) return;

            const first = focusable[0];
            const last = focusable[focusable.length - 1];
            if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
            } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
            }
        }
    }

    customElements.define("story-popup", StoryPopup);
}
